import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { Icon } from "@iconify/react";
import { useNavigate } from "@tanstack/react-router";

export const Notfound = () => {
  const navigate = useNavigate();

  return (
    <Stack
      spacing={3}
      sx={(theme) => ({
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        bgcolor: theme.palette.background.default,
        px: 2,
      })}
    >
      <Stack
        spacing={1}
        sx={{
          alignItems: "center",
        }}
      >
        <Typography
          variant="h1"
          sx={(theme) => ({
            fontSize: { xs: "4rem", md: "6rem" },
            fontWeight: 700,
            color: theme.palette.text.primary,
          })}
        >
          404
        </Typography>
        <Typography
          variant="h5"
          sx={(theme) => ({
            color: theme.palette.text.primary,
            fontWeight: 600,
          })}
        >
          Page non trouvée
        </Typography>
        <Typography
          variant="body1"
          sx={(theme) => ({
            color: theme.palette.text.secondary,
            textAlign: "center",
            maxWidth: 500,
          })}
        >
          Désolé, la page que vous recherchez n'existe pas ou a été déplacée.
        </Typography>
      </Stack>

      <Stack direction="row" spacing={2}>
        <Button
          variant="contained"
          startIcon={<Icon icon="tabler:home" />}
          onClick={() => navigate({ to: "/home" })}
        >
          Retour à l'accueil
        </Button>
        <Button
          variant="outlined"
          startIcon={<Icon icon="tabler:arrow-left" />}
          onClick={() => window.history.back()}
        >
          Retour
        </Button>
      </Stack>
    </Stack>
  );
};
